export interface LeadPayload {
  type: 'demo' | 'early_access';
  email: string;
  name?: string;
  phone?: string;
  organization?: string;
  role?: string;
  vertical?: string;
  notes?: string;
  /**
   * Optional plan tier the visitor expressed interest in. Set by the
   * /pricing page CTAs. The current /api/leads endpoint accepts arbitrary
   * fields and stores the JSON, so this is forward-compatible.
   */
  plan?: 'STARTER' | 'PRO' | 'ENTERPRISE' | 'UNLIMITED';
}

/**
 * POST a lead to the cloud backend. The /api/leads endpoint is added in a
 * follow-up backend task — until then, treat 404 as "captured client-side"
 * so the marketing site is shippable independently. Real failures (5xx,
 * network errors) still surface to the user.
 */
export async function submitLead(payload: LeadPayload): Promise<void> {
  let res: Response;
  try {
    res = await fetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (err) {
    // Network failure (offline, DNS, CORS). Log + surface.
    console.error('[leads] network error', err);
    throw new Error('Network error. Try again or email hello@opinix-us.com.');
  }

  if (res.ok) return;

  if (res.status === 404) {
    // Endpoint not deployed yet — log payload so it isn't lost on dev/preview.
    console.info('[leads] endpoint not available; logging payload', payload);
    return;
  }

  const body = await res.text().catch(() => '');
  console.error('[leads] backend error', res.status, body);
  throw new Error(`Server error (${res.status}). Try again shortly.`);
}
